(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["countdown-timer"] && !Shopify.designMode) return;
  try {
    (function () {
    const MS_SECOND = 1000;
    const MS_MINUTE = MS_SECOND * 60;
    const MS_HOUR = MS_MINUTE * 60;
    const MS_DAY = MS_HOUR * 24;

    function initCountdown(root) {
      const endDate = root.dataset.endDate;
      const endHour = Number(root.dataset.endHour || 0);
      const endMinute = Number(root.dataset.endMinute || 0);
      const hideOnComplete = root.dataset.hideOnComplete === 'true';

      if (!endDate) return;

      const end = new Date(`${endDate}T${String(endHour).padStart(2, '0')}:${String(endMinute).padStart(2, '0')}:00`);
      if (Number.isNaN(end.getTime())) return;

      function update() {
        const now = new Date();
        let diff = end.getTime() - now.getTime();

        if (diff <= 0) {
          diff = 0;
          if (hideOnComplete) {
            root.hidden = true;
          }
        }

        const daysEl = root.querySelector('[data-countdown-value="days"]');
        const hoursEl = root.querySelector('[data-countdown-value="hours"]');
        const minutesEl = root.querySelector('[data-countdown-value="minutes"]');
        const secondsEl = root.querySelector('[data-countdown-value="seconds"]');

        let days = 0;
        let hours = 0;
        let minutes = 0;
        let seconds = 0;

        if (diff > 0) {
        
            if (daysEl) {   
                days = Math.floor(diff / MS_DAY);
                diff -= days * MS_DAY;
            }

            if (hoursEl) {
                hours = Math.floor(diff / MS_HOUR);
                diff -= hours * MS_HOUR;
            }

            if (minutesEl) {
                minutes = Math.floor(diff / MS_MINUTE);
                diff -= minutes * MS_MINUTE;
            }  
            
            if (secondsEl) {
                seconds = Math.floor(diff / MS_SECOND);
            }
        }

        if (daysEl) daysEl.textContent = String(days).padStart(2, '0');
        if (hoursEl) hoursEl.textContent = String(hours).padStart(2, '0');
        if (minutesEl) minutesEl.textContent = String(minutes).padStart(2, '0');
        if (secondsEl) secondsEl.textContent = String(seconds).padStart(2, '0');
      }

      update();
      const interval = setInterval(() => {
        update();
        const now = new Date();
        if (end.getTime() - now.getTime() <= 0) {
          clearInterval(interval);
        }
      }, 1000);
    }

    function initAll() {
      document.querySelectorAll('[data-countdown-block]').forEach(initCountdown);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["inline-gallery-displayer"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const gallery = document.querySelector('.inline-gallery-displayer');
    const images = gallery.querySelectorAll('.image-block');

    if (!gallery || images.length === 0) return;

    let currentIndex = 0;
    let canCycle = true;

    // Retourne l'index de l'image hoverée, ou -1 si aucune
    function getHoveredIndex() {
      return Array.from(images).findIndex(img => img.matches(':hover'));
    }

    function resetImages() {
      images.forEach(img => img.classList.remove('auto-hover'));
    }

    function hoverImage(index) {
      images[index].classList.add('auto-hover');
    }

    // Cycle automatique toutes les 2 secondes
    setInterval(() => {
      if (!canCycle) return;
      resetImages();
      hoverImage(currentIndex);
      currentIndex = (currentIndex + 1) % images.length;
    }, 2000);

    // Vérifie très souvent si une image est hoverée
    setInterval(() => {
      const hoveredIndex = getHoveredIndex();
      canCycle = hoveredIndex === -1;

      if (!canCycle) {
        // laisse CSS hover agir
        resetImages();
        currentIndex = hoveredIndex + 1; // reprendra à cette image après hover
      }
    }, 500);

    // Initialisation
    hoverImage(currentIndex);
  });
  } catch(e) { console.error(e); }
})();

})();
